/*
 * Public API Surface of angular-location-selector
 */

export * from './lib/angular-location-selector.component';
export * from './lib/angular-location-selector.module';
